import { useRef, useState } from "react";

import MasonryImageList from "../components/MasonryImageList";
import { useRouter } from "next/router";
import Link from "next/link";
import { ChevronLeftIcon } from "@heroicons/react/20/solid";
import { Spinner } from "./Spinner";
import { generateCollectionUrl } from "../services/urls";
import ItemsProvider from "./ItemsProvider";

export default function CollectionLayout(props) {
    const router = useRouter();
    const [createLoading, setCreateLoading] = useState(false);
    const itemsProviderRef = useRef(
        new ItemsProvider(props.initialImages || [])
    );
    return (
        <div>
            <div className="sm:pt-8 md:pt-10">
                <div className="mx-auto text-center sm:text-left sm:px-16 sm:flex">
                    <div className="sm:hidden block containermt-4 container mx-auto mt-6 my-2 cursor-pointer font-semibold text-gray-600">
                        <Link href="/collection">
                            <div className="mx-4 sm:mx-16 flex items-center">
                                <ChevronLeftIcon className="h-4 mr-0.5" />
                                Collections
                            </div>
                        </Link>
                    </div>
                    <div className="pb-2 border-b sm:flex sm:flex-col sm:items-center sm:mb-8 sm:w-full lg:flex-row sm:mr-16 lg:mr-32 xl:mr-48 dark:border-gray-900">
                        <div className="sm:flex-1">
                            <h1 className="text-3xl font-semibold sm:block text-gray-900 sm:text-2xl  dark:text-gray-100">
                                <div className="mt-8 sm:mt-0 mx-4 sm:mx-0">
                                    {props.collectionName} Illustration Set
                                </div>
                            </h1>
                            <h2 className="text-gray-600 dark:text-gray-400 my-3 mx-4 sm:mx-0 mt-4 sm:mt-2">
                                {props.description}
                            </h2>
                        </div>
                        <div className="my-8 sm:my-0 inline-block sm:block items-center">
                            <div className="border border-gray-200 sm:border-0 p-4 sm:p-0 rounded bg-transparent mx-4 sm:mr-0 flex flex-col sm:flex-row items-center dark:border-gray-700 dark:bg-transparent">
                                <div className="text-xl sm:text-lg font-light sm:mr-8">
                                    Create images in this style
                                </div>
                                <div className="mt-4 sm:mt-0">
                                    <Link
                                        href={`/create?collection=${encodeURIComponent(
                                            props.collectionName
                                        )}`}
                                    >
                                        <button
                                            onClick={() =>
                                                setCreateLoading(true)
                                            }
                                            type="button"
                                            className="items-center font-bold bg-secondary-dark disabled:bg-gray-500 inline-flex justify-center rounded-md border px-4 py-2 text-base text-white  focus:outline-none sm:col-start-2 sm:text-sm shadow-md shadow-gray-100 hover:bg-secondary-darkest dark:shadow-none dark:border-0"
                                        >
                                            {createLoading ? (
                                                <div className="-ml-1 -mt-1 -mb-1 mr-1 w-6 h-6">
                                                    <Spinner />
                                                </div>
                                            ) : (
                                                <span className="text-lg mr-2 sparkle w-4">
                                                    <img
                                                        alt="Create now"
                                                        width="16"
                                                        height="15"
                                                        src="/sparkle-white.svg"
                                                    />
                                                </span>
                                            )}
                                            <div className="sm:block hidden">
                                                Create Now
                                            </div>
                                            <div className="block sm:hidden">
                                                Create
                                            </div>
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div></div>
                <div className="container lg:px-32 mx-auto">
                    {props.children}
                </div>
                <div className="sm:px-16 sm:pr-32 mx-auto w-full lg:mr-32 xl:mr-64">
                    <MasonryImageList
                        baseUrl={`/collection/${props.slug}`}
                        initialImages={props.initialImages}
                        initialQuery={props.initialQuery}
                        query={props.initialQuery}
                        canLoadMore={props.canLoadMore}
                        align="left"
                        itemsProvider={itemsProviderRef.current}
                        onItemClick={(item, i) => {
                            router.push(
                                generateCollectionUrl(props.slug, item)
                            );
                        }}
                    />
                </div>
                <div className="mt-16 sm:mt-0 md:pt-10">
                    <div className="mx-auto text-center  border-t border-gray-300 bg-gray-200 dark:border-gray-700 dark:bg-gray-900 ">
                        <div className="my-8 mx-auto inline-block">
                            <div className="p-8 lg:px-24 items-center justify-center ">
                                <div className="text-2xl font-light mb-3">
                                    Create images in this style
                                </div>
                                <div className="text-gray-600 dark:text-gray-400 mb-6">
                                    Generate SVG vector images in this style
                                    with AI
                                </div>
                                <div>
                                    <Link
                                        href={`/create?collection=${encodeURIComponent(
                                            props.collectionName
                                        )}`}
                                    >
                                        <button
                                            onClick={() =>
                                                setCreateLoading(true)
                                            }
                                            type="button"
                                            className="items-center font-bold bg-secondary-dark disabled:bg-gray-500 inline-flex justify-center rounded-md border px-4 py-2 text-base text-white  focus:outline-none sm:col-start-2 sm:text-sm shadow-md shadow-gray-100 hover:bg-secondary-darkest dark:shadow-none dark:border-0"
                                        >
                                            {createLoading ? (
                                                <div className="-ml-1 -mt-1 -mb-1 mr-1 w-6 h-6">
                                                    <Spinner />
                                                </div>
                                            ) : (
                                                <span className="text-lg mr-2 sparkle w-4">
                                                    <img
                                                        alt="Create now"
                                                        width="16"
                                                        height="15"
                                                        src="/sparkle-white.svg"
                                                    />
                                                </span>
                                            )}
                                            <div className="sm:block hidden">
                                                Create Now
                                            </div>
                                            <div className="block sm:hidden">
                                                Create
                                            </div>
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
